import { useState, useCallback } from 'react';
import { presignColeccionItemImageUpload, confirmColeccionItemImage } from 'api/coleccionItemImage';

/**
 * Hook para subir la foto de un item del catalogo a S3 via presigned URL.
 *
 * Flow:
 *   1) POST /colecciones/items/:itemId/image/presign-upload -> { uploadUrl, key }
 *   2) PUT directo al uploadUrl con Content-Type del archivo
 *   3) POST /colecciones/items/:itemId/image/confirm -> persiste image_key
 *   4) resolve(image_key)
 */
export function useColeccionItemImageUpload() {
  const [loading, setLoading] = useState(false);

  const upload = useCallback(async (itemId, file) => {
    if (!itemId) throw new Error('useColeccionItemImageUpload: itemId requerido');
    if (!file) throw new Error('useColeccionItemImageUpload: file requerido');
    setLoading(true);
    try {
      const contentType = file.type;
      const { uploadUrl, key } = await presignColeccionItemImageUpload(itemId, contentType);
      const putRes = await fetch(uploadUrl, {
        method: 'PUT',
        headers: { 'Content-Type': contentType },
        body: file,
      });
      if (!putRes.ok) {
        throw new Error(`S3 PUT failed: ${putRes.status} ${putRes.statusText}`);
      }
      const persistedKey = await confirmColeccionItemImage(itemId, key);
      return persistedKey;
    } finally {
      setLoading(false);
    }
  }, []);

  return { upload, loading };
}
